<template>
  <div>
    <div class="">
      <b-container-fluid>

        <b>المادة: {{ data.name }}</b>
        <br>
        <b>الدرس: {{ data.lessons[lessonIndex].title }}</b>
        <br><br>
        <ZoomMeeting :meetingId="meetingIdFromRoute" :userName="username" />

      </b-container-fluid>
    </div>
  </div>
</template>

<script>
import store from "../store/index.js";
import ZoomMeeting from '../components/courses/ZoomLive.vue';
import { sendRequest } from "../utils/RequestHelper.js";

export default {
  data() {
    return {
      username: '',
      meetingIdFromRoute: null,
      meetingPassword: '',
      data: {},
      lessonIndex: null,
    };
  },
  components: {
    ZoomMeeting,
  },
  watch: {
    $route(to) {
      this.extractRouteData(to);
    },
  },
  methods: {
    goToLink(link) {
      window.open(link, "_blank");
    },
    extractRouteData(route) {
      this.username = store.getters.username;
      this.meetingIdFromRoute = route.params.liveid;
    },
    loadData() {
      this.pageIsLoading = true;
      sendRequest('get', 'courses/courses/' + this.$route.params.id, true, null,
        (data) => {
          this.data = data;
          if (!this.data.is_paid) {
            this.$router.push({ name: 'course', params: { id: this.$route.params.id } });
          }
          this.data.lessons.forEach(element => {
            element['id'] = element.id;
            element['filename'] = element.title + element.title + element.title;
            element['date'] = element.date + ' / ' + element.time.substring(0, 5);
            element['files'] = element.explanation_file;
            element['exam'] = element.test_link;
            element['live'] = element.video_link;
          });
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    }
  },
  created() {
    if (store.getters.authToken) {
      this.extractRouteData(this.$route);
      this.loadData();
      this.lessonIndex = this.$route.params.lessonIndex
    } else {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>


<style scoped>
.course-details-section {
  padding: 30px 20px;
  background-color: #f5f5f5;
}

.course-card {
  padding: 20px 60px;
  border: none;
}

.table-data.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffcccc !important;
}

.course-image {
  height: 350px;
  object-fit: contain;
}

.course-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.course-details {
  font-size: 18px;
  margin-top: 10px;
}

.course-specifications {
  font-size: 21px;
}

.container {
  min-width: 250px;
}

.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

/* tabelt */

@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    min-width: 500px;
    padding: 0 !important;
  }

  .course-card {
    padding: 20px 10px;
  }

  .course-image {
    margin: 30px 10px;
    height: 150px !important;
  }

  .course-specifications {
    padding: 0 !important;
  }

}

/* mobile */

@media (max-width: 767px) {
  .container {
    min-width: 300px;
  }

  .course-card {
    padding: 20px 10px;
  }

  .course-image {
    margin: 30px 10px;
    height: 100px !important;
  }

  .course-specifications {
    margin: 0 !important;
  }
}
</style>
